import React, { useState, useRef, useEffect } from "react";
import "./faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Services Does Your Bfsi Software Development Company Offer?",
      a: "We offer comprehensive services in BFSI software development, including solutions for online banking, mobile banking apps, risk management, compliance tools, and more.",
    },
    {
      q: "Can You Develop a Customized Online Banking Platform Tailored to Our Specific Requirements?",
      a: "Absolutely. We specialize in developing secure and customized online banking platforms to meet the unique needs and branding of our clients.",
    },
    {
      q: "How Does Your Software Ensure the Security of Online Banking and Mobile Banking Transactions?",
      a: "We implement multi-factor authentication (MFA), encryption, and advanced security measures to ensure the security of online and mobile banking transactions.",
    },
    {
      q: "Does Your Software Include Tools for Transaction Monitoring and Fraud Detection?",
      a: "Yes, we integrate advanced analytics and AI-driven tools for real-time transaction monitoring and fraud detection to enhance security.",
    },
    {
      q: "Can Your Software Help in Managing Customer Relationships and Improving Customer Engagement?",
      a: "Certainly. We develop Customer Relationship Management (CRM) systems to manage customer interactions, track leads, and personalize communication for better relationships.",
    },
    {
      q: "How Does Your Software Address Compliance With Regulatory Requirements in the Banking and Financial Industry?",
      a: "Our software includes tools for risk management and compliance, ensuring adherence to regulatory requirements and industry standards.",
    },
    {
      q: "Can You Develop a Loan Management System to Streamline the Lending Process?",
      a: "Yes, we specialize in developing comprehensive loan management systems for efficient loan origination, processing, underwriting, and management.",
    },
    {
      q: "Does Your Software Offer Tools for Investment Management and Financial Planning?",
      a: "Absolutely. We provide platforms for portfolio management, investment tracking, and financial planning for clients and institutional investors.",
    },
    {
      q: "How Does Your Software Handle Insurance Policy Administration, Including Claims Processing and Renewals?",
      a: "We develop systems for insurance policy administration, covering policy issuance, underwriting, claims processing, and renewals.",
    },
    {
      q: "What Kind of Real-time Analytics and Reporting Tools Does Your Software Offer for Financial Performance?",
      a: "Our software provides real-time analytics and reporting tools for financial performance, customer behavior, and operational insights, enabling informed decision-making.",
    },
    {
      q: "How Do You Support Open Banking Initiatives, and Do You Provide Apis for Third-party Integration?",
      a: "We support open banking by providing secure APIs for data sharing and interoperability with third-party financial services, promoting collaboration and expanded service offerings.",
    },
    {
      q: "What Measures Does Your Software Take to Ensure Kyc (Know Your Customer) and Aml (Anti-money Laundering) Compliance?",
      a: "We implement robust KYC and AML processes to verify customer identities and prevent money laundering activities, ensuring regulatory compliance.",
    },
    {
      q: "Does Your Software Include Chatbots and Virtual Assistants for Customer Support?",
      a: "Yes, we integrate chatbots and virtual assistants to provide instant customer support, answer queries, and assist with routine banking tasks.",
    },
    {
      q: "Can Your Software Support Digital Wallets for Secure and Convenient Payments?",
      a: "Certainly. We support digital wallets, enabling users to make secure and convenient transactions using their mobile devices.",
    },
    {
      q: "Have You Explored Blockchain Technology for Secure Transactions, and Can Your Software Integrate Cryptocurrency Features?",
      a: "Yes, we explore blockchain technology for secure transactions and can integrate cryptocurrency features based on client requirements.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  

  // Get height for smooth animation
  const getHeight = (index) => {
    const el = answerRefs.current[index];
    if (!el) return "0px";

    const padding = 40; // top 20 + bottom 20
    return `${el.scrollHeight + padding}px`;
  };

 
  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
